"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TotalRowController = (function () {
    function TotalRowController() {
    }
    TotalRowController.calcTotalRow = function (rows, totalRow, periodFields, isOnlineApi) {
        TotalRowController.sumUp(rows, totalRow, "contacts_total");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absolute1");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absolute2");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absolute3");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absolute4");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absolute5");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absoluteAE");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.absoluteCashDiscount");
        TotalRowController.sumUp(rows, totalRow, "specialDiscounts.net");
        if (periodFields) {
            TotalRowController.setUniqueCaption(rows, totalRow, "medium.period", function (row) {
                return periodFields[_.get(row, "medium.period")];
            });
        }
        if (isOnlineApi) {
            TotalRowController.setUniqueCaption(rows, totalRow, "conditions.online.adFormat", function (row) {
                var adFormat = _.get(row, "conditions.online.adFormat");
                if (adFormat) {
                    if (adFormat.currentItem && adFormat.currentItem.name) {
                        return adFormat.currentItem.name;
                    }
                    else {
                        return "Keine Werbeform";
                    }
                }
            });
        }
        return totalRow;
    };
    TotalRowController.sumUp = function (rows, totalRow, path) {
        var result = 0;
        rows.forEach(function (row) {
            if (_.get(row, "_group") === undefined && _.get(row, path)) {
                result += parseFloat(_.get(row, path).toString());
            }
        });
        _.set(totalRow, path, result);
    };
    TotalRowController.setUniqueCaption = function (rows, totalRow, path, retrievalMethod) {
        var stringArray = new Array();
        rows.forEach(function (row) {
            var value = retrievalMethod(row);
            if (value !== undefined) {
                stringArray.push(value);
            }
        });
        if (stringArray.length === 0) {
            return;
        }
        var value = _.uniq(stringArray).length === 1 ? stringArray[0] : "Diverse";
        _.set(totalRow, path, value);
    };
    return TotalRowController;
}());
exports.TotalRowController = TotalRowController;
//# sourceMappingURL=TotalRowController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/TotalRowController.js
// module id = 70
// module chunks = 0